module.exports = __webpack_public_path__ + "static/media/bonusSpins_10_15.d7170454.png";